import config from '@/app/config'
import { MapRouteShell } from '@/app/shell/map-route-shell'
import {
  normalizeStormHeatmapRowMode,
  type StormHeatmapRowMode,
} from '@/features/storm-heatmap/components/StormHeatmapCalendar'
import {
  buildStormHeatmapPath,
} from '@/features/storm-heatmap/components/StormHeatmapPage'
import {
  normalizeStormHeatmapColorMetricKey,
  type StormHeatmapColorMetricKey,
} from '@/features/storm-heatmap/metrics'
import StormHeatmapPage from '@/features/storm-heatmap/components/StormHeatmapPage'
import { parseSearch } from '@/app/router/search-params'
import { createFileRoute } from '@tanstack/react-router'
import React from 'react'

export const Route = createFileRoute('/heatmap/$colorMetricKey/$mode')({
  validateSearch: parseSearch,
  component: RouteComponent,
  head: () => ({
    meta: [
      { title: 'FloodNet NYC Storm History' },
      { name: 'description', content: 'Explore historical FloodNet flooding observations by date, depth, and event count.' },
    ],
  }),
})

function RouteComponent() {
  const params = Route.useParams()
  const search = Route.useSearch()
  const now = React.useMemo(() => new Date(), [])
  const from = React.useMemo(() => new Date(config.START_OF_PROJECT_TIME).toISOString(), [])
  const to = React.useMemo(() => new Date(now.getTime() + 2 * 24 * 60 * 60 * 1000).toISOString(), [now])
  const colorMetricKey = normalizeStormHeatmapColorMetricKey(params.colorMetricKey)
  const mode = normalizeStormHeatmapRowMode(params.mode)
  const routePath = React.useMemo(
    () => buildStormHeatmapPath(colorMetricKey, mode),
    [colorMetricKey, mode],
  )

  return (
    <MapRouteShell routePath={routePath} search={search} timeFrom={from} timeTo={to}>
      <StormHeatmapPage
        colorMetricKey={colorMetricKey as StormHeatmapColorMetricKey}
        mode={mode as StormHeatmapRowMode}
      />
    </MapRouteShell>
  )
}
